import { createSlice } from "@reduxjs/toolkit";

const imgSlice = createSlice({
  name: "img",
  initialState: {
    data: "",
  },
  reducers: {
    getEditImage: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { getEditImage } = imgSlice.actions;

export default imgSlice.reducer;
